export const apiUrl = () => {
    // return 'http://localhost:3001';
    return 'https://seapi.infobip.com'
}





